<template>
    <main>
        <div class="main" style="padding-top:0">
            <dl class="titleTip">
                <dt>病例分析</dt>
                <dd></dd>
           </dl>
            <ul class="ulBox">
                <li @click.stop="toCaseyDetailsPage(item.caseId)"
                    v-for="item in activityList"
                    :key="item.activityId">
                    <div>
                        <h2>{{item.name}}</h2>
                        <span>{{item.time}}</span>
                    </div>
                    <p>{{item.content}}</p>
                </li>
            </ul>
            <!-- 分页器 -->
          <Pager :countNumber.sync="countNumber"
                 :currentPage.sync="currentPage"
                 :pagesizeList.sync="pagesizeList"
                 :pagesize.sync="pagesize"
                 :showPagesize="false"
          ></Pager>
        </div>
    </main>
</template>
<script>
    import Pager from '../../../components/Pager/Pager';
    export default {
        name: 'Activity',
        components: {
            'Pager': Pager,
        },
        created() {
            this.getAllActivityListByLimit();
        },
        data() {
            return {
                activityList: [],
                // 分页器
                countNumber: 0,
                currentPage:1, // 当前页数
                pagesizeList: [5, 10, 20, 50, 100],
                pagesize: 5,
            }
        },
        methods: {
            getAllActivityListByLimit() {
                const start = (this.currentPage-1) * this.pagesize;
                const params = {
                    start: start,
                    limit: this.pagesize,
                };
                if (start < 0 || typeof params.start !== 'number' || typeof params.limit !== 'number') {
                    return;
                }
                this.$api.getAllActivityListByLimit(params).then(r => {
                    if (r.code === 1) {
                        this.countNumber = r.data.countNumber;
                        this.activityList = r.data.data;
                    } else {
                        console.error(r.message)
                    }
                })
            },
            toCaseyDetailsPage(id) {
              this.$router.push({  path: '/activity/casedetails?caseId='+id,})
                /*let newpage = this.$router.resolve({
                    path: '/activity/casedetails?caseId='+id,
                })
                window.open(newpage.href, '_blank');*/
            },
        },
        watch: {
            currentPage() {
                this.getAllActivityListByLimit();
            },
            pagesize() {
                this.getAllActivityListByLimit();
            },
        }
    }

</script>
<style lang="scss" scoped>
    @import './Activity.scss';
</style>
